export class VivitekProjector3and4Series {
    constructor(socket, log) {
        this.socket = socket;
        this.displayBlank = false;
        this.displayFreeze = false;
        this.input = '6'; // hdmi 1
        this.power = false;
        this.firmwareVersion = 'LX166-L95VV-P05';
        this.asyncHandlers = [
            {
                name: 'displayBlank',
                regExp: /V99[GS]0302(\d)?/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1]) {
                            this.displayBlank = match[1] === '1';
                            this.socket.send(`P`);
                        }
                        else {
                            this.socket.send(`P${this.displayBlank ? '1' : '0'}`);
                        }
                    }
                },
            },
            {
                name: 'displayFreeze',
                regExp: /V99[GS]0304(\d)?/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1]) {
                            this.displayFreeze = match[1] === '1';
                            this.socket.send(`P`);
                        }
                        else {
                            this.socket.send(`P${this.displayFreeze ? '1' : '0'}`);
                        }
                    }
                },
            },
            {
                name: 'firmwareVersionGet',
                regExp: /V99G0008/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`P${this.firmwareVersion}`);
                    }
                },
            },
            {
                name: 'videoInputGet',
                regExp: /V99G0220/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`P${this.input}`);
                    }
                },
            },
            {
                name: 'videoInputSet',
                regExp: /V99S02(\d+)/i,
                callback: (match) => {
                    if (this.power) {
                        this.input = match[1];
                        this.socket.send(`P`);
                    }
                },
            },
            {
                name: 'powerGet',
                regExp: /V99G0007/i,
                callback: (match) => {
                    this.socket.send(`P${this.power ? '2' : '1'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /V99S000(\d)/i,
                callback: (match) => {
                    this.power = match[1] === '1';
                    this.socket.send(`P`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.input === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.input = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '6';
    }
}
VivitekProjector3and4Series.emulatorType = 'socketEmulator';
VivitekProjector3and4Series.key = '-LiPkvMQzkAHqC1lEcYK';
